module.exports = __webpack_public_path__ + "static/media/2_FAI.efdf402e.svg";